import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  return <section id="hero" className="flex min-h-[calc(100svh-2.5rem)] items-center bg-white px-4 py-5 text-center sm:py-6" data-id="element-101" data-mp="2hvm4m8t8rmbp">
      <motion.div initial={{
      opacity: 0,
      y: 16
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.3,
      ease: [0.23, 1, 0.32, 1]
    }} className="mx-auto flex w-full max-w-4xl flex-col items-center justify-center" data-id="element-102" data-mp="23xeae8nlaz48">
        <p className="mb-2 font-note text-[9px] font-semibold tracking-[0.24em] text-sage sm:mb-3 sm:text-[11px]" data-id="element-103" data-mp="30k0u2rnwusae">
          IL REPERTORIO COMPLETO PER ISTRUTTORI REFORMER
        </p>
        <h1 className="max-w-3xl text-[1.85rem] font-bold leading-[1.08] tracking-tight text-petrol sm:text-[2.6rem] md:text-[3.1rem]" data-id="element-104" data-mp="2rs78urxfsteh">
          Prepara un anno intero di lezioni di Reformer in <span className="italic text-sage" data-id="element-105" data-mp="3k9tfdsw7l3t3">cinque</span> minuti
        </h1>
        <p className="mt-2.5 max-w-2xl text-[13px] leading-snug text-muted sm:mt-3 sm:text-sm md:text-base" data-id="element-106" data-mp="2ffibxtlnf7q1">
          Pilates Reformer Pronto è la collezione completa e pronta all&apos;uso: 6 volumi con sequenze illustrate,
          schede esercizio, progressioni su tre livelli e piani di lezione già scritti. Scarica, stampa ed entra in
          sala.
        </p>
        <img src="https://cdn.magicpatterns.com/uploads/whWU15xcPWR1CBvN2oZwe4/ChatGPT_Image_8_sept_2026,_20_50_15.png" alt="I sei volumi di Pilates Reformer Pronto mostrati su tablet, computer e smartphone insieme alle schede stampate" className="my-3 h-[30svh] w-full max-w-3xl object-contain sm:my-4 sm:h-[34svh] md:h-[36svh]" data-id="element-107" data-mp="2kdadlfc3i87f" />
        <CTAButton className="w-full max-w-sm py-3.5 text-[13px] sm:max-w-md sm:py-4 sm:text-sm md:text-base" data-id="element-108" data-mp="3365x3gkkrtuj" />
        <p className="mt-2.5 max-w-xl font-note text-[10px] leading-relaxed text-muted sm:mt-3 sm:text-xs" data-id="element-109" data-mp="1dqy35zq8xpj0">
          Download immediato in PDF · Pagamento unico di 19 € · Garanzia soddisfatti o rimborsati di 30 giorni
        </p>
      </motion.div>
    </section>;
}